
<template>
  <div>
    <data-list :payload="listPayloadObj" :headers="headers" v-model="pagination" :total="total" :pagination="pagination"></data-list>
    <v-dialog v-model="dialog" width="750" persistent>
      <form-template :references.sync="formReferences" :model="modelObj" ref="fieldsReference"></form-template>
    </v-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import DataList from '../../components/DataList.vue'
import FormTemplate from '../../components/FormTemplate'
export default {
  data () {
    return {
      total: 0,
      dialog: false,
      modelObj: { isactive: true },
      listPayloadObj: {
        isHeader: true,
        isHideAdd: true,
        selection: [],
        showSelect: true,
        list: [],
        loading: false,
        page: 1,
        editProp: 'name',
        addClickHandler: this.openDialogHandler,
        editHandler: this.getSingleRecordHandler,
        defaultListSearch: true
      },
      loading: false,
      pagination: !this.$formatter.isEmptyObject(this.$store.state.GROUP_INDEX) ? this.$store.state.GROUP_INDEX : { sortBy: ['name'], itemsPerPage: 25, sortDesc: [false], search: '' },
      MODULE: 'groups'
    }
  },
  components: {
    DataList,
    FormTemplate
  },
  computed: {
    headers () {
      return [{
        text: '#',
        value: 'id',
        isRoute: true,
        isModal: true,
        width: '10%'
      }, {
        text: this.$t('message.customer.name'),
        value: 'name',
        isRoute: true,
        isModal: true,
        width: '50%'
      }, {
        text: this.$t('message.tickets.mailbox'),
        value: 'mailboxName',
        width: '40%'
      }]
    },
    ...mapState(['FORM_TYPE', 'listOfMailboxes']),
    formReferences () {
      return {
        title: this.modelObj.id ? this.$t('message.group.updateGroup') : this.$t('message.group.addGroup'),
        properties: [{
          model: 'name',
          type: this.FORM_TYPE.TEXT,
          rules: this.$_requiredValidation,
          label: this.$t('message.customer.name'),
          class: 'xs12'
        }, {
          model: 'mailboxid',
          type: this.FORM_TYPE.AUTO_COMPLETE,
          rules: this.$_requiredValidation,
          items: this.listOfMailboxes,
          select_text: 'name',
          select_value: 'id',
          multiple: true,
          label: this.$t('message.tickets.mailbox'),
          class: 'xs12'
        }],
        buttons: [{
          name: 'action_handler',
          color: 'success',
          label: this.modelObj.id ? this.$t('message.common.update') : this.$t('message.common.save'),
          click: this.saveUpdateHandler,
          loading: this.loading,
          is_show: true
        }, {
          name: 'close',
          color: 'error',
          click: this.closeDialogHandler,
          label: this.$t('message.common.close'),
          is_show: true
        }]
      }
    }
  },
  watch: {
    pagination: {
      handler (val) {
        let model = {
          type: 'GROUP_INDEX',
          data: val
        }
        this.$store.commit('rememberOrder', model)
      },
      deep: true
    }
  },
  mounted () {
    this.$store.dispatch('getMailbox')
    this.getListHandler()
    let text = this.$t('message.common.deleteMsg')
    this.$eventBus.$on('deleteItems', (data) => {
      if (data.module === this.MODULE) {
        let payload = { ids: data.ids, url: `${this.MODULE}/delete_multiple`, module: this.MODULE }
        this.$store.commit('showDeleteDialog', payload)
      }
    })
    this.$eventBus.$on('deleteSuccess', (data) => {
      if (data === this.MODULE) {
        this.listPayloadObj.selection = []
        this.$root.$emit('snackbar', { snackbar: true, color: 'success', text })
        this.$store.commit('hideDialog')
        this.getListHandler()
      }
    })
  },
  methods: {
    getListHandler () {
      this.listPayloadObj.loading = true
      this.listPayloadObj.module = this.MODULE
      this.$_executeApi('get', `groups/get_with_access`).then((response) => {
        let data = response.data
        data.forEach(element => {
          element.mailboxName = []
          if (element.mailboxes.length > 0) {
            element.mailboxes.forEach(mailbox => {
              element.mailboxName.push(mailbox.mailboxname)
            })
          }
          element.mailboxName = element.mailboxName.join()
        })
        this.listPayloadObj.loading = false
        this.listPayloadObj.list = data
        if (this.pagination.page > 1 && this.total <= this.pagination.itemsPerPage * (this.pagination.page - 1)) {
          this.pagination.page = 1
          this.listPayloadObj.page = 1
        }
      })
    },
    getSingleRecordHandler (id) {
      let query = {
        filter: `id eq ${id}`,
        expandasobject: [{
          'model': 'MailboxAccess',
          'on_field': 'groupid',
          'on_parent_field': 'id'
        }]
      }
      this.$_executeApi('post', `${this.MODULE}/query`, query)
        .then((result) => {
          if (result.data) {
            this.$set(this.modelObj, 'id', result.data[0].group.id)
            this.modelObj.name = result.data[0].group.name
            var mailboxid = []
            if (result.data[0].mailboxaccess.length > 0) {
              result.data[0].mailboxaccess.forEach(mailbox => {
                mailboxid.push(mailbox.mailboxid)
              })
            }
          }
          this.modelObj.mailboxid = mailboxid
          this.dialog = true
        })
    },
    openDialogHandler () {
      this.modelObj.isactive = true
      this.dialog = true
    },
    closeDialogHandler () {
      this.dialog = false
      // this.modelObj.id = undefined
      this.modelObj = {}
      this.$refs.fieldsReference.$refs.validateForm.reset()
    },
    saveUpdateHandler () {
      if (this.$refs.fieldsReference.$refs.validateForm.validate()) {
        this.loading = true
        let model = this.modelObj
        let { url, method, text } = ''
        if (!model.id) {
          url = this.MODULE
          method = 'post'
          text = this.$t('message.common.savedSuccess')
        } else {
          url = `${this.MODULE}/${model.id}`
          method = 'put'
          text = this.$t('message.common.updatedSuccess')
        }
        this.$_executeApi(method, url, model)
          .then((response) => {
            let data = { ids: model.mailboxid }
            this.$_executeApi('post', `${this.MODULE}/update_access/${response.data.id}`, data).then(response => {
              this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: text })
              this.closeDialogHandler()
              this.getListHandler()
            })
          })
          .finally(() => {
            this.loading = false
          })
      } else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: this.$t('message.common.validationIssue') })
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('deleteSuccess')
    this.$eventBus.$off('deleteItems')
  }
}
</script>
